// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { SectionContainer, SectionTitle } from "@eisinc/App/Widgets/DesignSystem/DesignSystem.helpers";
import translate from "@insite/client-framework/Translate";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Tab from "@insite/mobius/Tab/Tab";
import TabGroup from "@insite/mobius/TabGroup/TabGroup";
import React, { FC } from "react";
import { css } from "styled-components";

interface TabsStyles {
    titleGridItem?: GridItemProps;
    gridItem?: GridItemProps;
}

const tabsStyles: TabsStyles = {
    titleGridItem: {
        width: 12,
    },
    gridItem: {
        width: 12,
        css: css`
            flex-wrap: wrap;
            padding-bottom: 40px;
        `,
    },
};

const styles = tabsStyles;

const tabs = [
    {
        headline: "Selected",
    },
    {
        headline: "Tab 2",
    },
    {
        headline: "Tab3",
    },
];
const TabsTab: FC = props => {
    return (
        <SectionContainer>
            <GridItem {...styles.titleGridItem}>
                <SectionTitle>{translate("Tabs")}</SectionTitle>
            </GridItem>
            <GridItem {...styles.gridItem}>
                <TabGroup>
                    {tabs.map(tab => (
                        <Tab key={tab.headline} headline={tab.headline} tabKey={tab.headline}>
                            {tab.headline}
                        </Tab>
                    ))}
                </TabGroup>
            </GridItem>
        </SectionContainer>
    );
};

export default TabsTab;
